<template>
    <kt-form-group>
        <kt-form-label :for="idf">
            {{ title }}
        </kt-form-label>
        <kt-form-control
                disabled
                :value="val"
                :id="idf"
                :name="idf"
        ></kt-form-control>
    </kt-form-group>
</template>

<script>
export default {
    props: {
        val: {
            require: true,
        },
        title: {
            require: true,
        },
        idf: {
            require: true,
        },
    },
}
</script>

<style scoped>
</style>